(function() {
    angular
        .module("app")
        .controller("ConfirmMessageModalController", ConfirmMessageModalController)

    ConfirmMessageModalController.$inject = [
        "$rootScope",
        "$scope",
        "$state",
        "$stateParams",
        "$uibModal",
        "$uibModalInstance",
        "messagesService",
        "userMessagingService",
        "previewImage",
        "messageData",
        "messageType"
    ]

    function ConfirmMessageModalController(
        $rootScope,
        $scope,
        $state,
        $stateParams,
        $uibModal,
        $uibModalInstance,
        messagesService,
        userMessagingService,
        previewImage,
        messageData,
        messageType
    ){
        "use strict"

        $scope.$watch("messageNumber", function() {
            $scope.messageNumberEdit = !$scope.messageNumber
        })

        /**
            $scope variables
         **/
        $scope.activateNewMessage = false
        $scope.isUpdate = false
        $scope.image_url = previewImage.image_url
        $scope.message_type = messageType
        $scope.messageID = {}
        $scope.messageData = messageData

        /**
            Create message
         **/
        $scope.createMessage = function() {
            $scope.activateNewMessage = false

            if($stateParams.message_board_id.split(",").length == 1) {
                $scope.createNewMessage()
            } else {
                $scope.broadcastMessage()
            }
        }

        /**
            Create and activate message
         **/
        $scope.createAndActivateMessage = function() {
            $scope.activateNewMessage = true

            if($stateParams.message_board_id.split(",").length == 1) {
                $scope.createNewMessage()
            } else {
                $scope.broadcastMessage()
            }
        }

        /**
            Create new message
         **/
        $scope.createNewMessage = function() {
            $scope.messageData.message.activate = $scope.activateNewMessage

            if($scope.messageNumber) {
                if($scope.isUpdate) {
                    $uibModalInstance.close()

                    var modalInstance = $uibModal.open({
                        templateUrl: "app/modals/message-overwrite-warning-modal.view.html",
                        controller: "MessageOverwriteWarningModalController",
                        resolve: {
                            messageData: function() {
                                return $scope.messageData
                            },
                            messageID: function() {
                                return $scope.messageID
                            },
                            isActivate: function() {
                                return $scope.activateNewMessage
                            }
                        }
                    }).result.catch(function(res) {
                        if (!(res === "cancel" || res === "escape key press")) {
                            throw res
                        }
                    })

                } else {
                    messagesService.createMessage(
                        $stateParams.message_board_id,
                        $scope.messageData,
                        function(data) {
                            //Success
                            $uibModalInstance.close()

                            $state.go("device-message-board.details", {message_board_id: $stateParams.message_board_id}).then(() => {
                                userMessagingService.success("Message Creation Request Sent")
                            })
                        },
                        function(error) {
                            //Failure
                            $uibModalInstance.dismiss("cancel")
                            userMessagingService.error("Message Creation Failed: " + error)
                        }
                    )
                }
            } else {
                $scope.messageNumberError = true
            }
        }

        /**
            Broadcast message
         **/
        $scope.broadcastMessage = function() {
            messagesService.broadcastMessage(
                $stateParams.message_board_id,
                $scope.messageData,
                function(response) {
                    //Success
                    $uibModalInstance.close()
                    $state.go("devices").then(() => {
                        userMessagingService.success("Message Broadcast Request Sent")
                    })
                },
                function(error) {
                    //Failure
                    $uibModalInstance.close()
                    $state.go("devices").then(() => {
                        userMessagingService.error(error)
                    })
                }
            )

        }

        /**
            Set message number
         **/
        $scope.setMessageNumber = function(messageNumber) {
            if(messageNumber.id) {
                $scope.setIsUpdate(true)
            } else {
                $scope.setIsUpdate(false)
            }

            $scope.messageNumberError = false
            $scope.messageNumber = messageNumber.message_number
            $scope.messageData.message.message_number = messageNumber.message_number
        }

        /**
            Set isUpdate
         **/
        $scope.setIsUpdate = function(isUpdate) {
            $scope.isUpdate = isUpdate
        }

        /**
            Set message ID
         **/
        $scope.setMessageID = function(messageID) {
            $scope.messageID = messageID
        }

        $scope.cancel = function() {
            $uibModalInstance.dismiss("cancel")
        }
    }
})()
